import { useStatsigClient } from '@statsig/react-bindings';

export const useGate = (gateName: string) => {
  const statsigClient = useStatsigClient();
  return () => statsigClient.checkGate(gateName);
};
